import { render, staticRenderFns } from "./Date.vue?vue&type=template&id=5364dbff&scoped=true"
import script from "./Date.vue?vue&type=script&lang=js"
export * from "./Date.vue?vue&type=script&lang=js"
import style0 from "./Date.vue?vue&type=style&index=0&id=5364dbff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5364dbff",
  null
  
)

export default component.exports